import React from "react";
import { Link } from "gatsby";
import clsx from "clsx";

export interface PostBreadCrumbsLink {
  to?: string;
  content: string;
}

interface IBreadCrumbsProps extends React.PropsWithChildren {
  links: PostBreadCrumbsLink[];
}

export default function BreadCrumbs(props: IBreadCrumbsProps) {
  const { links } = props;

  return (
    <div className="bg-base-200 breadcrumbs flex flex-col items-center px-4 py-2 text-sm w-full">
      <ul className={clsx("lg:max-w-3xl", "md:max-w-2xl", "w-full")}>
        {links.map(({ to, content }) => {
          return (
            
            <li key={to}>{to ? <Link to={to}>{content}</Link> : content}</li>
          );
        })}
      </ul>
    </div>
  );
}
